module.exports = __webpack_public_path__ + "img/Blast_Off_Club_House44.cd2040fb.jpg";